import { render } from "./index.vue?vue&type=template&id=6ca36f21&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6ca36f21&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca36f21"],['__file',"src/views/people/level/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ca36f21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ca36f21', __exports__)) {
    console.log('reload')
    api.reload('6ca36f21', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6ca36f21&scoped=true", () => {
    console.log('re-render')
    api.rerender('6ca36f21', render)
  })

}


export default __exports__